import React, { useState, useEffect } from "react";
import { SFIconButton, SFIcons } from "@sf-core";

const ExpandAllHeader = (props) => {
  const [allExpanded, setAllExpanded] = useState(true);
  const { api } = props;

  useEffect(() => {
    api.forEachNode((node) => {
      node.setData({ ...node.data, expanded: allExpanded });
    });
    api.refreshCells({ force: true });
  }, [allExpanded, api]);

  const toggleAll = () => {
    setAllExpanded(!allExpanded);
  };

  return (
    <SFIconButton variant="unhovered" onClick={toggleAll}>
      {allExpanded ? (
        <SFIcons.SFArrowUpIcon color="primary" />
      ) : (
        <SFIcons.SFArrowDownIcon color="primary" />
      )}
    </SFIconButton>
  );
};

export default ExpandAllHeader;
